var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 223,
    viewBox: "0 0 349 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.969727,
    width: 349,
    height: 222,
    rx: 15,
    fill: "#FAAC1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.174 32.0535C120.174 32.0535 140.378 22.0832 178.33 53.221C216.283 84.3588 281.906 73.1615 292.136 101.845C302.366 130.529 219.658 220.977 153.983 214.688C88.3083 208.399 70.3039 172.864 71.7872 127.614C73.2706 82.3648 69.5878 48.1592 120.174 32.0535Z",
    fill: "#FCC257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.163 146.685L257.611 183.447C261.549 185.697 265.999 185.697 269.886 183.447L279.196 178.488C280.525 177.721 281.293 176.443 281.293 174.909C281.293 173.375 280.525 172.046 279.196 171.33L214.697 134.517C210.758 132.267 206.309 132.267 202.37 134.517L193.112 139.476C191.782 140.192 191.015 141.521 191.015 143.055C191.066 144.64 191.833 145.918 193.163 146.685Z",
    fill: "#236687"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.851 132.574C195.567 132.574 196.181 133.187 196.181 133.903V141.163C196.181 141.879 195.567 142.493 194.851 142.493C194.135 142.493 193.521 141.879 193.521 141.163V133.903C193.521 133.187 194.135 132.574 194.851 132.574Z",
    fill: "#2A3B42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.953 171.79C264.669 171.79 265.283 172.403 265.283 173.119V180.38C265.283 181.095 264.669 181.709 263.953 181.709C263.237 181.709 262.623 181.095 262.623 180.38V173.119C262.623 172.403 263.237 171.79 263.953 171.79Z",
    fill: "#2A3B42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.968 164.632C278.684 164.632 279.298 165.245 279.298 165.961V173.221C279.298 173.937 278.684 174.551 277.968 174.551C277.252 174.551 276.638 173.937 276.638 173.221V165.961C276.587 165.245 277.201 164.632 277.968 164.632Z",
    fill: "#2A3B42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.317 139.63L257.764 176.392C261.703 178.641 266.153 178.641 270.04 176.392L279.349 171.432C280.679 170.665 281.446 169.387 281.446 167.853C281.446 166.319 280.679 164.99 279.349 164.274L214.851 127.461C210.912 125.211 206.462 125.211 202.524 127.461L193.266 132.42C191.936 133.136 191.169 134.465 191.169 135.999C191.22 137.533 191.987 138.863 193.317 139.63Z",
    fill: "#425460"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.163 138.351L257.611 175.113C261.549 177.363 265.999 177.363 269.886 175.113L279.196 170.154C280.525 169.387 281.293 168.108 281.293 166.575C281.293 165.041 280.525 163.711 279.196 162.996L214.697 126.182C210.758 123.933 206.309 123.933 202.37 126.182L193.112 131.142C191.782 131.858 191.015 133.187 191.015 134.721C191.066 136.255 191.833 137.584 193.163 138.351Z",
    fill: "#576A7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.851 95.4027C195.567 95.4027 196.181 96.0162 196.181 96.732V134.312C196.181 135.028 195.567 135.642 194.851 135.642C194.135 135.642 193.521 135.028 193.521 134.312V96.732C193.521 96.0162 194.135 95.4027 194.851 95.4027Z",
    fill: "#2A3B42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.866 88.2447C209.582 88.2447 210.196 88.8582 210.196 89.5741V127.154C210.196 127.87 209.582 128.484 208.866 128.484C208.15 128.484 207.536 127.87 207.536 127.154V89.5741C207.485 88.8582 208.099 88.2447 208.866 88.2447Z",
    fill: "#84D3D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.728 132.267V97.3964C203.598 99.3905 206.974 100.822 210.196 100.618C213.418 100.413 215.618 99.0837 216.283 97.5498V132.267C216.283 141.726 202.728 141.726 202.728 132.267Z",
    fill: "url(#paint0_linear_929_7247)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.212 132.267V99.0838C205.695 100.158 207.997 100.771 210.247 100.618C212.447 100.464 214.186 99.7997 215.26 98.8793V132.267C215.209 139.681 204.212 140.038 204.212 132.267Z",
    fill: "#7D2834"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.045 141.675V106.804C219.914 108.798 223.29 110.23 226.512 110.026C229.735 109.821 231.934 108.492 232.599 106.958V141.675C232.599 151.134 219.045 151.134 219.045 141.675Z",
    fill: "url(#paint1_linear_929_7247)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.477 141.675V108.492C221.96 109.566 224.262 110.179 226.512 110.026C228.712 109.872 230.451 109.208 231.525 108.287V141.675C231.525 149.089 220.477 149.447 220.477 141.675Z",
    fill: "#646BAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.361 151.083V116.212C236.23 118.206 239.606 119.638 242.829 119.433C246.051 119.229 248.25 117.9 248.915 116.366V151.083C248.915 160.541 235.361 160.541 235.361 151.083Z",
    fill: "url(#paint2_linear_929_7247)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.793 151.083V117.9C238.276 118.973 240.578 119.587 242.829 119.433C245.028 119.28 246.767 118.615 247.841 117.695V151.083C247.841 158.496 236.793 158.854 236.793 151.083Z",
    fill: "#FC8E05"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.626 160.49V125.62C252.496 127.614 255.872 129.046 259.094 128.841C262.316 128.637 264.516 127.307 265.181 125.773V160.49C265.181 169.949 251.626 169.949 251.626 160.49Z",
    fill: "url(#paint3_linear_929_7247)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.11 160.49V127.307C254.593 128.381 256.895 128.995 259.145 128.841C261.345 128.688 263.084 128.023 264.158 127.103V160.49C264.107 167.904 253.11 168.262 253.11 160.49Z",
    fill: "#E3E4E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.953 134.619C264.669 134.619 265.283 135.232 265.283 135.948V173.528C265.283 174.244 264.669 174.858 263.953 174.858C263.237 174.858 262.623 174.244 262.623 173.528V135.948C262.623 135.181 263.237 134.619 263.953 134.619Z",
    fill: "#2A3B42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.968 127.461C278.684 127.461 279.298 128.074 279.298 128.79V166.37C279.298 167.086 278.684 167.7 277.968 167.7C277.252 167.7 276.638 167.086 276.638 166.37V128.79C276.587 128.023 277.201 127.461 277.968 127.461Z",
    fill: "#2A3B42"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.317 101.231L257.764 137.993C261.703 140.243 266.153 140.243 270.04 137.993L279.349 133.034C280.679 132.267 281.446 130.988 281.446 129.455C281.446 127.921 280.679 126.591 279.349 125.876L214.851 89.0624C210.912 86.8127 206.462 86.8127 202.524 89.0624L193.266 94.0219C191.936 94.7377 191.169 96.0671 191.169 97.601C191.22 99.1349 191.987 100.464 193.317 101.231Z",
    fill: "#425460"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.163 99.953L257.611 136.715C261.549 138.965 265.999 138.965 269.886 136.715L279.196 131.755C280.525 130.989 281.293 129.71 281.293 128.176C281.293 126.643 280.525 125.313 279.196 124.597L214.697 87.7842C210.758 85.5345 206.309 85.5345 202.37 87.7842L193.112 92.7437C191.782 93.4596 191.015 94.7889 191.015 96.3228C191.066 97.9078 191.833 99.186 193.163 99.953Z",
    fill: "#576A7A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.326 91.8748C204.927 92.1816 201.807 94.4824 202.421 97.0388C202.984 99.5953 207.024 101.385 211.423 101.129C215.822 100.822 218.942 98.5216 218.328 95.9651C217.766 93.4087 213.725 91.568 209.326 91.8748Z",
    fill: "#6A7C91"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.728 97.1922V81.9045H216.334V97.2945C215.669 98.9306 213.469 100.311 210.247 100.567C206.973 100.822 203.597 99.2885 202.728 97.1922Z",
    fill: "url(#paint4_linear_929_7247)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.16 99.0328V92.2326H215.208V98.8794C214.134 99.7998 212.395 100.464 210.196 100.618C207.997 100.771 205.695 100.107 204.16 99.0328Z",
    fill: "#7D2834"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.268 78.7353C202.268 78.8376 202.268 78.9398 202.268 78.991V80.4737C202.268 80.6782 202.268 80.9339 202.319 81.1384C202.83 83.4392 206.513 85.1265 210.503 84.8708C214.185 84.6152 216.845 82.8257 216.845 80.7294V78.7353C216.845 78.633 216.794 78.5308 216.794 78.4285C216.282 76.1277 212.6 74.4404 208.61 74.6961C205.03 75.0029 202.37 76.7413 202.268 78.7353Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.268 78.7353C202.268 78.8376 202.268 78.9398 202.268 78.991V79.3991C203.188 81.5465 206.82 83.1315 210.349 82.8759C213.878 82.6202 216.18 81.1886 216.947 79.5013V78.6833C216.947 78.581 216.896 78.4787 216.896 78.3765C216.385 76.0756 212.702 74.3884 208.712 74.644C205.03 75.0019 202.37 76.7413 202.268 78.7353Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.741 82.0067C208.559 82.1601 209.428 82.2112 210.298 82.1601C213.469 81.9556 215.669 80.2683 215.259 78.4788C215.004 77.405 213.93 76.4847 212.395 75.9734C211.577 75.82 210.707 75.7689 209.838 75.82C206.666 76.0245 204.467 77.7118 204.876 79.5013C205.132 80.6262 206.206 81.5465 207.741 82.0067Z",
    fill: "#576A7A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.741 82.0067C208.559 82.1601 209.428 82.2112 210.298 82.1601C212.088 82.0578 213.571 81.4443 214.441 80.6774C213.265 79.6037 211.116 78.939 208.815 79.0924C207.331 79.1946 206.053 79.6037 205.183 80.2172C205.643 80.9841 206.564 81.6488 207.741 82.0067Z",
    fill: "#CEB8D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.741 82.0067C208.559 82.1601 209.428 82.2112 210.298 82.1601C212.497 82.0067 214.288 81.1372 215.004 80.0124C213.725 78.6319 211.321 77.7627 208.763 77.9672C207.178 78.0695 205.848 78.5807 204.876 79.2966C204.876 79.3477 204.876 79.45 204.927 79.5011C205.132 80.6259 206.206 81.5465 207.741 82.0067Z",
    fill: "#E3E7F2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.904 92.8973C203.904 92.9996 203.904 93.0507 203.904 93.1018V93.4086C204.62 95.0448 207.434 96.2719 210.145 96.1185C212.855 95.914 214.697 94.8402 215.259 93.5109V92.8973C215.259 92.8462 215.259 92.7439 215.208 92.6928C214.799 90.9033 211.935 89.625 208.866 89.8295C206.053 90.0341 203.956 91.3634 203.904 92.8973Z",
    fill: "url(#paint5_linear_929_7247)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.694 101.231C221.295 101.538 218.175 103.839 218.789 106.396C219.351 108.952 223.392 110.742 227.791 110.486C232.19 110.179 235.31 107.878 234.696 105.322C234.133 102.714 230.093 100.925 225.694 101.231Z",
    fill: "#6A7C91"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.096 106.447V90.699H232.701V106.6C232.036 108.288 229.837 109.719 226.615 109.975C223.341 110.179 219.965 108.594 219.096 106.447Z",
    fill: "url(#paint6_linear_929_7247)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.579 108.39V101.589H231.627V108.236C230.553 109.157 228.814 109.821 226.615 109.975C224.364 110.077 222.062 109.412 220.579 108.39Z",
    fill: "#646BAE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.635 88.0922C218.635 88.1944 218.635 88.2967 218.635 88.3478V89.8306C218.635 90.0351 218.635 90.2907 218.687 90.4952C219.198 92.7961 222.881 94.4833 226.87 94.2277C230.553 93.972 233.213 92.1825 233.213 90.0862V88.0922C233.213 87.9899 233.213 87.8876 233.162 87.7854C232.65 85.4846 228.967 83.7973 224.978 84.0529C221.397 84.3086 218.738 86.047 218.635 88.0922Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.635 88.0922C218.635 88.1944 218.635 88.2967 218.635 88.3478V88.7559C219.556 90.9034 223.188 92.4884 226.717 92.2327C230.246 91.9771 232.548 90.5455 233.315 88.8582V88.0401C233.315 87.9379 233.315 87.8356 233.264 87.7333C232.752 85.4325 229.07 83.7453 225.08 84.0009C221.397 84.3077 218.738 86.047 218.635 88.0922Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.108 91.3636C224.927 91.517 225.796 91.5681 226.666 91.517C229.837 91.3124 232.036 89.6252 231.627 87.8356C231.371 86.7619 230.297 85.8416 228.763 85.3303C227.944 85.1769 227.075 85.1258 226.205 85.1769C223.034 85.3814 220.835 87.0687 221.244 88.8582C221.5 89.9319 222.574 90.8523 224.108 91.3636Z",
    fill: "#576A7A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.108 91.3636C224.927 91.517 225.796 91.5681 226.666 91.517C228.456 91.4147 229.939 90.8012 230.809 90.0343C229.632 88.9605 227.484 88.2959 225.182 88.4492C223.699 88.5515 222.42 88.9605 221.551 89.5741C222.011 90.341 222.932 90.9545 224.108 91.3636Z",
    fill: "#CEB8D9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.108 91.3636C224.927 91.517 225.796 91.5681 226.666 91.517C228.865 91.3636 230.655 90.4941 231.371 89.3693C230.093 87.9888 227.689 87.1196 225.131 87.3241C223.546 87.4263 222.216 87.9376 221.244 88.6535C221.244 88.7046 221.244 88.8068 221.295 88.858C221.5 89.9317 222.574 90.8523 224.108 91.3636Z",
    fill: "#E3E7F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.272 102.254C220.272 102.356 220.272 102.408 220.272 102.459V102.765C220.988 104.402 223.801 105.629 226.512 105.475C229.223 105.271 231.064 104.197 231.627 102.868V102.254C231.627 102.203 231.627 102.101 231.576 102.05C231.167 100.26 228.302 98.9819 225.234 99.1864C222.42 99.3398 220.374 100.669 220.272 102.254Z",
    fill: "#A1A6CE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.908 110.691C237.509 110.997 234.389 113.298 235.003 115.855C235.565 118.411 239.606 120.201 244.005 119.945C248.404 119.638 251.524 117.337 250.91 114.781C250.347 112.224 246.307 110.384 241.908 110.691Z",
    fill: "#6A7C91"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.31 115.854V99.7998H248.915V116.008C248.25 117.746 246.051 119.178 242.829 119.433C239.555 119.638 236.179 118.053 235.31 115.854Z",
    fill: "url(#paint7_linear_929_7247)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.793 117.849V111.048H247.841V117.695C246.767 118.615 245.028 119.28 242.829 119.433C240.578 119.587 238.276 118.922 236.793 117.849Z",
    fill: "#FC8E05"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.849 97.5522C234.849 97.6545 234.849 97.7568 234.849 97.8079V99.2906C234.849 99.4952 234.849 99.7508 234.901 99.9553C235.412 102.256 239.095 103.943 243.084 103.688C246.767 103.432 249.427 101.643 249.427 99.5463V97.5522C249.427 97.45 249.427 97.3477 249.376 97.2455C248.864 94.9447 245.181 93.2574 241.192 93.513C237.611 93.8198 234.952 95.5582 234.849 97.5522Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.849 97.5502C234.849 97.6524 234.849 97.7547 234.849 97.8058V98.2149C235.77 100.362 239.402 101.947 242.931 101.692C246.46 101.436 248.762 100.004 249.529 98.3171V97.4991C249.529 97.3968 249.529 97.2945 249.478 97.1923C248.966 94.8914 245.284 93.2042 241.294 93.4598C237.611 93.8177 234.952 95.5561 234.849 97.5502Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.322 100.874C241.141 101.027 242.01 101.078 242.88 101.027C246.051 100.823 248.25 99.1352 247.841 97.3457C247.585 96.272 246.511 95.3517 244.977 94.8404C244.158 94.687 243.289 94.6358 242.419 94.687C239.248 94.8915 237.049 96.5788 237.458 98.3683C237.714 99.442 238.839 100.362 240.322 100.874Z",
    fill: "#576A7A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.322 100.874C241.141 101.027 242.01 101.078 242.88 101.027C244.67 100.925 246.153 100.311 247.023 99.5443C245.846 98.4706 243.698 97.8059 241.396 97.9593C239.913 98.0616 238.634 98.4706 237.765 99.0841C238.225 99.8 239.146 100.465 240.322 100.874Z",
    fill: "#CEB8D9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.322 100.874C241.141 101.027 242.01 101.078 242.88 101.027C245.079 100.874 246.869 100.005 247.585 98.8797C246.307 97.4992 243.903 96.63 241.345 96.8345C239.76 96.9368 238.43 97.4481 237.458 98.1639C237.458 98.215 237.458 98.3173 237.509 98.3684C237.714 99.4422 238.839 100.362 240.322 100.874Z",
    fill: "#E3E7F2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.486 111.713C236.486 111.815 236.486 111.866 236.486 111.918V112.224C237.202 113.861 240.015 115.088 242.726 114.934C245.437 114.73 247.278 113.656 247.841 112.327V111.713C247.841 111.662 247.841 111.56 247.79 111.509C247.381 109.719 244.516 108.441 241.448 108.645C238.634 108.85 236.588 110.179 236.486 111.713Z",
    fill: "#FCC257"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.275 120.098C253.877 120.405 250.757 122.706 251.37 125.262C251.933 127.819 255.974 129.608 260.373 129.353C264.771 129.046 267.891 126.745 267.278 124.188C266.664 121.632 262.623 119.791 258.275 120.098Z",
    fill: "#6A7C91"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.677 125.262V109.156H265.283V125.364C264.618 127.103 262.419 128.534 259.196 128.79C255.872 129.046 252.496 127.461 251.677 125.262Z",
    fill: "url(#paint8_linear_929_7247)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.11 127.256V120.456H264.158V127.103C263.084 128.023 261.345 128.688 259.145 128.841C256.895 128.995 254.593 128.33 253.11 127.256Z",
    fill: "#E3E4E5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.166 106.959C251.166 107.061 251.166 107.163 251.166 107.214V108.697C251.166 108.902 251.166 109.157 251.217 109.362C251.729 111.663 255.411 113.35 259.401 113.094C263.084 112.839 265.743 111.049 265.743 108.953V106.959C265.743 106.856 265.743 106.754 265.692 106.652C265.181 104.351 261.498 102.664 257.508 102.919C253.928 103.226 251.268 104.965 251.166 106.959Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.166 106.959C251.166 107.061 251.166 107.163 251.166 107.214V107.622C252.087 109.77 255.718 111.355 259.247 111.099C262.777 110.844 265.078 109.412 265.846 107.725V106.907C265.846 106.804 265.846 106.702 265.795 106.6C265.283 104.299 261.6 102.612 257.611 102.867C253.928 103.225 251.268 104.965 251.166 106.959Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.69 110.23C257.509 110.383 258.378 110.435 259.248 110.383C262.419 110.179 264.618 108.492 264.209 106.702C263.953 105.628 262.879 104.708 261.345 104.197C260.526 104.043 259.657 103.992 258.787 104.043C255.616 104.248 253.417 105.935 253.826 107.725C254.03 108.85 255.156 109.719 256.69 110.23Z",
    fill: "#576A7A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.69 110.23C257.509 110.383 258.378 110.435 259.248 110.383C261.038 110.281 262.521 109.668 263.391 108.901C262.214 107.827 260.066 107.162 257.764 107.316C256.281 107.418 255.002 107.827 254.133 108.441C254.542 109.208 255.514 109.872 256.69 110.23Z",
    fill: "#CEB8D9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.69 110.23C257.509 110.383 258.378 110.435 259.248 110.383C261.447 110.23 263.237 109.361 263.953 108.236C262.674 106.855 260.27 105.986 257.713 106.191C256.127 106.293 254.797 106.804 253.826 107.52C253.826 107.571 253.826 107.673 253.877 107.725C254.03 108.849 255.156 109.719 256.69 110.23Z",
    fill: "#E3E7F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.803 121.121C252.803 121.223 252.803 121.274 252.803 121.325V121.632C253.519 123.268 256.332 124.495 259.043 124.342C261.754 124.137 263.595 123.064 264.158 121.734V121.121C264.158 121.07 264.158 120.967 264.107 120.916C263.697 119.127 260.833 117.848 257.764 118.053C254.951 118.206 252.905 119.587 252.803 121.121Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.126 150.367L130.302 164.683C132.194 165.961 134.598 166.421 136.849 165.859L179.66 155.531C181.092 155.173 181.348 153.23 180.069 152.514L153.114 137.482C151.17 136.408 148.92 136.102 146.72 136.562L110.098 144.947C107.592 145.509 106.978 148.884 109.126 150.367Z",
    fill: "#236687"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M202.83 60.3277C207.378 60.3277 211.065 56.6422 211.065 52.0959C211.065 47.5496 207.378 43.8641 202.83 43.8641C198.282 43.8641 194.595 47.5496 194.595 52.0959C194.595 56.6422 198.282 60.3277 202.83 60.3277Z",
    fill: "#FCC257"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5085 214.892C76.8644 214.892 82.017 209.742 82.017 203.388C82.017 197.034 76.8644 191.884 70.5085 191.884C64.1525 191.884 59 197.034 59 203.388C59 209.742 64.1525 214.892 70.5085 214.892Z",
    fill: "#646BAE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M273.467 82.5182C279.823 82.5182 284.975 77.3677 284.975 71.0141C284.975 64.6606 279.823 59.51 273.467 59.51C267.111 59.51 261.958 64.6606 261.958 71.0141C261.958 77.3677 267.111 82.5182 273.467 82.5182Z",
    fill: "#646BAE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7583 33.1783C99.99 33.1783 105.852 27.3181 105.852 20.0891C105.852 12.8602 99.99 7 92.7583 7C85.5266 7 79.6642 12.8602 79.6642 20.0891C79.6642 27.3181 85.5266 33.1783 92.7583 33.1783Z",
    fill: "#FCC257"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.528 92.3346V65.7984C152.193 67.2812 154.75 68.406 157.206 68.2527C159.661 68.0993 161.349 67.0767 161.86 65.9007V92.3346C161.86 99.5438 151.528 99.5438 151.528 92.3346Z",
    fill: "url(#paint9_linear_929_7247)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.653 92.3345V67.0766C153.779 67.8947 155.518 68.3549 157.257 68.2526C158.945 68.1503 160.275 67.639 161.093 66.9232V92.3345C161.042 97.9588 152.653 98.2656 152.653 92.3345Z",
    fill: "#FC8E05"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.528 65.4916V53.2717H161.86V65.645C161.349 66.9744 159.661 68.0481 157.206 68.2527C154.75 68.406 152.193 67.1789 151.528 65.4916Z",
    fill: "url(#paint10_linear_929_7247)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.602 67.0257V61.8616H160.991V66.9235C160.172 67.5881 158.843 68.0994 157.155 68.2528C155.518 68.3551 153.779 67.8438 152.602 67.0257Z",
    fill: "#FC8E05"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.17 51.5847C151.17 51.6869 151.17 51.738 151.17 51.7892V52.914C151.17 53.0674 151.17 53.2719 151.221 53.4253C151.63 55.2148 154.444 56.442 157.461 56.2374C160.275 56.0329 162.321 54.7036 162.321 53.0674V51.5335C162.321 51.4824 162.321 51.3801 162.269 51.329C161.86 49.5395 159.047 48.3124 156.029 48.5169C153.267 48.7214 151.221 50.0508 151.17 51.5847Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.17 51.5867C151.17 51.689 151.17 51.7401 151.17 51.7912V52.098C151.886 53.7342 154.648 54.9101 157.308 54.7568C159.968 54.5522 161.758 53.4785 162.321 52.2003V51.5867C162.321 51.5356 162.321 51.4333 162.269 51.3822C161.86 49.5927 159.047 48.3656 156.029 48.5701C153.267 48.7235 151.221 50.0528 151.17 51.5867Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.313 54.0901C155.927 54.1923 156.592 54.2435 157.257 54.1923C159.661 54.0389 161.349 52.7607 161.042 51.3802C160.837 50.5621 160.019 49.8974 158.842 49.4884C158.229 49.3861 157.564 49.335 156.899 49.3862C154.495 49.5395 152.807 50.8178 153.114 52.1983C153.318 53.0163 154.188 53.681 155.313 54.0901Z",
    fill: "#576A7A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.313 54.0901C155.927 54.1923 156.592 54.2435 157.257 54.1923C158.587 54.0901 159.712 53.681 160.428 53.0674C159.559 52.2494 157.871 51.7381 156.132 51.8915C155.006 51.9426 154.035 52.3005 153.37 52.7607C153.728 53.3231 154.444 53.7833 155.313 54.0901Z",
    fill: "#CEB8D9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.313 54.0901C155.927 54.1923 156.592 54.2435 157.257 54.1923C158.945 54.0901 160.275 53.4252 160.837 52.556C159.865 51.4823 158.024 50.8176 156.08 50.971C154.904 51.0733 153.83 51.4312 153.114 51.9936C153.114 52.0448 153.114 52.0959 153.165 52.147C153.318 53.0162 154.188 53.681 155.313 54.0901Z",
    fill: "#E3E7F2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.398 62.3731C152.398 62.4242 152.398 62.4754 152.398 62.5265V62.7821C152.909 64.0604 155.109 64.9807 157.155 64.8273C159.201 64.6739 160.633 63.8559 161.042 62.8333V62.3731C161.042 62.322 161.042 62.2708 160.991 62.2197C160.684 60.8392 158.536 59.8678 156.132 60.0211C154.035 60.1745 152.449 61.1971 152.398 62.3731Z",
    fill: "#FCC257"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M150.557 61.3506V61.9131C150.557 62.8334 151.017 63.7026 151.835 64.1627C152.654 64.674 154.035 65.1853 156.234 65.3899C159.252 65.7478 161.247 65.1853 162.321 64.7252C162.986 64.4184 163.446 63.7537 163.446 63.0379V61.7597C163.446 61.4529 163.139 61.2484 162.883 61.2995C161.247 61.7597 156.234 62.7822 151.682 60.6348C151.17 60.4303 150.557 60.7882 150.557 61.3506Z",
    fill: "#CCD2E8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5694 158.139V156.451L108.308 156.349V158.139H86.5694Z",
    fill: "#646BAE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4129 162.741C103.43 162.741 108.308 160.703 108.308 158.19C108.308 155.677 103.43 153.64 97.4129 153.64C91.396 153.64 86.5182 155.677 86.5182 158.19C86.5182 160.703 91.396 162.741 97.4129 162.741Z",
    fill: "#646BAE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4129 160.746C103.43 160.746 108.308 158.824 108.308 156.452C108.308 154.08 103.43 152.157 97.4129 152.157C91.396 152.157 86.5182 154.08 86.5182 156.452C86.5182 158.824 91.396 160.746 97.4129 160.746Z",
    fill: "#A1A6CE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9025 153.639C101.71 153.639 105.598 155.173 105.598 157.065C105.598 157.167 105.598 157.27 105.547 157.372C105.905 157.014 106.109 156.554 106.109 156.145C106.109 154.253 102.222 152.719 97.414 152.719C92.8617 152.719 89.1279 154.1 88.7698 155.889C89.9974 154.56 93.1686 153.639 96.9025 153.639Z",
    fill: "#1A4E63"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M97.413 159.622C101.147 159.622 104.318 158.701 105.546 157.423C105.546 157.321 105.597 157.219 105.597 157.116C105.597 155.225 101.71 153.691 96.9016 153.691C93.1677 153.691 89.9974 154.611 88.7698 155.889C88.7698 155.991 88.7177 156.094 88.7177 156.196C88.7177 158.037 92.6051 159.622 97.413 159.622Z",
    fill: "#2F83A5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M105.137 157.678C105.239 157.576 107.285 155.838 107.796 153.997C108.308 152.156 108.41 149.907 108.41 149.907L106.978 150.929C106.978 150.929 107.643 150.674 107.643 148.833C107.643 146.941 107.234 145.203 107.234 145.203L105.597 146.941C105.597 146.941 105.699 145.049 104.983 144.129C104.267 143.209 103.602 140.857 103.602 140.857C103.602 140.857 101.556 143.516 101.198 144.436C101.198 144.436 100.482 144.027 100.38 142.288C100.226 140.601 100.738 138.709 100.738 138.709C100.738 138.709 94.5999 143.516 94.7022 146.379L93.3212 143.413C93.3212 143.413 91.0707 146.328 91.2753 147.964L88.8201 146.072C88.8201 146.072 89.4339 147.401 89.0759 149.242C88.7178 151.083 88.4109 151.901 88.7178 152.77C89.0247 153.639 88.8201 152.923 88.8201 152.923L86.9276 151.594C86.9276 151.594 86.9788 154.917 88.7178 156.656C90.508 158.343 90.3034 158.496 93.7816 159.11C97.2597 159.724 102.733 158.957 103.704 158.701C104.727 158.343 105.137 157.678 105.137 157.678Z",
    fill: "#FC8E05"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M101.812 159.161C102.17 159.161 105.085 155.633 105.75 152.975C106.415 150.316 106.211 149.396 106.211 149.396L104.42 151.287C104.42 151.287 104.574 149.549 104.011 148.577C103.449 147.606 102.988 145.663 102.988 145.663L100.84 148.731C100.84 148.731 99.3055 146.021 99.152 144.998C98.9986 143.976 99.2032 144.743 99.2032 144.743C99.2032 144.743 97.0549 147.453 96.8503 148.884L96.032 146.686C96.032 146.686 94.0883 148.884 93.8326 150.674L92.3492 149.549C92.3492 149.549 92.2981 151.492 91.9401 152.821C91.582 154.151 92.0935 155.736 92.0935 155.736L90.4056 155.122C90.4056 155.122 90.8659 158.701 92.8607 159.11C95.009 159.417 101.812 159.161 101.812 159.161Z",
    fill: "#FCC257"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2315 159.11C98.2315 159.11 101.812 158.445 100.84 152.361L98.743 153.946C98.743 153.946 97.1062 152.974 97.8223 151.594C97.8223 151.594 95.8787 153.077 95.9298 155.071C95.981 157.014 96.1856 157.32 96.1856 157.32L94.4977 156.247C94.4465 156.247 94.4465 159.161 98.2315 159.11Z",
    fill: "#E86D6D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M139.662 67.6906L154.7 62.6799C155.365 62.4754 156.03 62.9355 156.03 63.6513C156.03 64.4183 155.569 65.083 154.853 65.3386L139.508 70.8606L139.662 67.6906Z",
    fill: "#959AA3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0549 135.539C105.085 135.539 111.581 128.893 111.581 120.712C111.581 112.531 105.034 105.884 97.0549 105.884C89.0245 105.884 82.5286 112.531 82.5286 120.712C82.5286 128.893 89.0757 135.539 97.0549 135.539Z",
    fill: "url(#paint11_linear_929_7247)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.055 133.596C104.523 133.596 110.661 127.512 110.661 119.996C110.661 112.531 104.574 106.396 97.055 106.396C89.5873 106.396 83.4495 112.48 83.4495 119.996C83.4495 127.512 89.5873 133.596 97.055 133.596Z",
    fill: "url(#paint12_linear_929_7247)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.279 121.785C108.614 127.921 103.448 132.727 97.1059 132.727C90.7635 132.727 85.5463 127.921 84.9325 121.785H109.279Z",
    fill: "#646BAE"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1446 88.9093L92.1958 110.128C92.1958 113.861 101.965 113.963 101.965 110.128V88.9093C102.477 84.6656 91.6332 84.6145 92.1446 88.9093Z",
    fill: "url(#paint13_linear_929_7247)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5768 91.0057V110.69C93.5768 113.349 100.482 113.4 100.482 110.69V91.0057C100.891 87.989 93.2187 87.989 93.5768 91.0057Z",
    fill: "url(#paint14_linear_929_7247)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.039 87.7332C103.039 87.6309 103.039 87.5287 102.988 87.3753C102.579 85.5857 99.5612 84.3586 96.2365 84.5632C93.2187 84.7677 91.0193 86.1482 91.0193 87.7332V88.9092C91.0193 89.0625 91.0193 89.1648 91.0705 89.3182C91.4797 91.1077 94.4975 92.3348 97.8221 92.1303C100.891 91.9258 103.09 90.5453 103.039 88.9092V87.7332Z",
    fill: "url(#paint15_linear_929_7247)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3388 84.87C93.321 85.0745 91.2239 86.5061 91.5819 88.1423C91.9911 89.7784 94.7531 90.9033 97.7709 90.7499C100.789 90.5454 102.886 89.1137 102.528 87.4776C102.119 85.8414 99.3565 84.6655 96.3388 84.87Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5434 85.6881C94.3951 85.8415 92.9118 86.8641 93.1675 87.989C93.4233 89.1138 95.4181 89.983 97.5663 89.8296C99.7146 89.6762 101.198 88.6537 100.942 87.5288C100.635 86.404 98.6916 85.5859 96.5434 85.6881Z",
    fill: "#576A7A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5433 86.864C94.9577 86.9663 93.7301 87.5798 93.3209 88.3468C93.8324 89.3182 95.6226 89.9829 97.5663 89.8807C99.1519 89.7784 100.379 89.1649 100.789 88.3979C100.277 87.3753 98.487 86.7106 96.5433 86.864Z",
    fill: "#E3E7F2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4694 114.679C88.769 115.139 84.0633 118.616 84.9328 122.501C85.8023 126.387 91.9402 129.148 98.6407 128.688C105.341 128.228 110.047 124.751 109.177 120.865C108.257 116.979 102.119 114.218 95.4694 114.679Z",
    fill: "#A1A6CE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6969 116.57C97.3466 116.57 97.8733 116.044 97.8733 115.394C97.8733 114.745 97.3466 114.218 96.6969 114.218C96.0471 114.218 95.5204 114.745 95.5204 115.394C95.5204 116.044 96.0471 116.57 96.6969 116.57Z",
    fill: "#646BAE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8221 112.633C98.7826 112.633 99.5612 111.855 99.5612 110.895C99.5612 109.935 98.7826 109.157 97.8221 109.157C96.8617 109.157 96.0831 109.935 96.0831 110.895C96.0831 111.855 96.8617 112.633 97.8221 112.633Z",
    fill: "#A1A6CE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8783 106.498C96.8388 106.498 97.6174 105.72 97.6174 104.76C97.6174 103.8 96.8388 103.021 95.8783 103.021C94.9179 103.021 94.1393 103.8 94.1393 104.76C94.1393 105.72 94.9179 106.498 95.8783 106.498Z",
    fill: "#A1A6CE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0779 100.055C99.0383 100.055 99.8169 99.2771 99.8169 98.317C99.8169 97.3569 99.0383 96.5786 98.0779 96.5786C97.1174 96.5786 96.3388 97.3569 96.3388 98.317C96.3388 99.2771 97.1174 100.055 98.0779 100.055Z",
    fill: "#A1A6CE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9242 81.24C98.8847 81.24 99.6633 80.4617 99.6633 79.5016C99.6633 78.5415 98.8847 77.7632 97.9242 77.7632C96.9637 77.7632 96.1851 78.5415 96.1851 79.5016C96.1851 80.4617 96.9637 81.24 97.9242 81.24Z",
    fill: "#646BAE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3208 78.6834C94.2813 78.6834 95.0599 77.9051 95.0599 76.945C95.0599 75.985 94.2813 75.2066 93.3208 75.2066C92.3604 75.2066 91.5817 75.985 91.5817 76.945C91.5817 77.9051 92.3604 78.6834 93.3208 78.6834Z",
    fill: "#A1A6CE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5434 95.9141C97.5039 95.9141 98.2825 95.1358 98.2825 94.1757C98.2825 93.2156 97.5039 92.4373 96.5434 92.4373C95.583 92.4373 94.8044 93.2156 94.8044 94.1757C94.8044 95.1358 95.583 95.9141 96.5434 95.9141Z",
    fill: "#A1A6CE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6226 121.018C96.1875 121.018 96.6455 120.744 96.6455 120.405C96.6455 120.066 96.1875 119.791 95.6226 119.791C95.0576 119.791 94.5996 120.066 94.5996 120.405C94.5996 120.744 95.0576 121.018 95.6226 121.018Z",
    fill: "#646BAE"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9473 120.15C99.7948 120.15 100.482 119.76 100.482 119.28C100.482 118.8 99.7948 118.411 98.9473 118.411C98.0999 118.411 97.4129 118.8 97.4129 119.28C97.4129 119.76 98.0999 120.15 98.9473 120.15Z",
    fill: "#646BAE"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9984 121.786C99.5634 121.786 100.021 121.511 100.021 121.172C100.021 120.833 99.5634 120.558 98.9984 120.558C98.4335 120.558 97.9755 120.833 97.9755 121.172C97.9755 121.511 98.4335 121.786 98.9984 121.786Z",
    fill: "#646BAE"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8274 122.655C96.3923 122.655 96.8503 122.38 96.8503 122.041C96.8503 121.703 96.3923 121.428 95.8274 121.428C95.2624 121.428 94.8044 121.703 94.8044 122.041C94.8044 122.38 95.2624 122.655 95.8274 122.655Z",
    fill: "#646BAE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2032 123.217C99.5704 123.217 99.8681 123.057 99.8681 122.859C99.8681 122.662 99.5704 122.501 99.2032 122.501C98.836 122.501 98.5383 122.662 98.5383 122.859C98.5383 123.057 98.836 123.217 99.2032 123.217Z",
    fill: "#646BAE"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6226 121.018C96.1875 121.018 96.6455 120.744 96.6455 120.405C96.6455 120.066 96.1875 119.791 95.6226 119.791C95.0576 119.791 94.5996 120.066 94.5996 120.405C94.5996 120.744 95.0576 121.018 95.6226 121.018Z",
    fill: "#646BAE"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9473 120.15C99.7948 120.15 100.482 119.76 100.482 119.28C100.482 118.8 99.7948 118.411 98.9473 118.411C98.0999 118.411 97.4129 118.8 97.4129 119.28C97.4129 119.76 98.0999 120.15 98.9473 120.15Z",
    fill: "#646BAE"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9984 121.786C99.5634 121.786 100.021 121.511 100.021 121.172C100.021 120.833 99.5634 120.558 98.9984 120.558C98.4335 120.558 97.9755 120.833 97.9755 121.172C97.9755 121.511 98.4335 121.786 98.9984 121.786Z",
    fill: "#646BAE"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8274 122.655C96.3923 122.655 96.8503 122.38 96.8503 122.041C96.8503 121.703 96.3923 121.428 95.8274 121.428C95.2624 121.428 94.8044 121.703 94.8044 122.041C94.8044 122.38 95.2624 122.655 95.8274 122.655Z",
    fill: "#646BAE"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2032 123.217C99.5704 123.217 99.8681 123.057 99.8681 122.859C99.8681 122.662 99.5704 122.501 99.2032 122.501C98.836 122.501 98.5383 122.662 98.5383 122.859C98.5383 123.057 98.836 123.217 99.2032 123.217Z",
    fill: "#646BAE"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M173.983 148.066V153.281L112.298 148.424V142.902L173.983 148.066Z",
    fill: "#ACB2BF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M113.423 150.265L131.274 162.331C132.91 163.405 134.905 163.763 136.798 163.303L172.858 154.611C174.085 154.304 174.29 152.668 173.216 152.105L150.506 139.425C148.869 138.505 146.976 138.249 145.135 138.658L114.241 145.714C112.093 146.225 111.581 149.037 113.423 150.265Z",
    fill: "#ACB2BF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M113.423 145.049L131.274 157.116C132.91 158.19 134.905 158.548 136.798 158.087L172.858 149.395C174.085 149.089 174.29 147.453 173.216 146.89L150.506 134.21C148.869 133.29 146.976 133.034 145.135 133.443L114.241 140.499C112.093 141.01 111.581 143.822 113.423 145.049Z",
    fill: "#CCD2E8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 87.6823C134.7 87.6823 136.081 89.5741 134.547 91.7726L99.5612 99.7488L99.7147 95.9652L134.7 87.6823Z",
    fill: "#959AA3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M141.554 141.368H134.291V62.0152C134.291 60.0211 135.928 58.385 137.923 58.385C139.917 58.385 141.554 60.0211 141.554 62.0152V141.368Z",
    fill: "#ACB2BF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M137.872 142.902C139.849 142.902 141.452 142.215 141.452 141.368C141.452 140.521 139.849 139.834 137.872 139.834C135.894 139.834 134.291 140.521 134.291 141.368C134.291 142.215 135.894 142.902 137.872 142.902Z",
    fill: "#ACB2BF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9682 97.0387V98.317C90.9682 98.8794 91.2751 99.3907 91.7354 99.6463C93.321 100.464 97.0038 101.896 101.761 100.106C102.374 99.8509 102.784 99.2884 102.784 98.6237V97.2433C102.784 96.6297 102.17 96.2207 101.607 96.4763C100.124 97.141 97.1061 97.8057 92.0935 96.1695C91.582 96.0162 91.0193 96.4252 90.9682 97.0387Z",
    fill: "#CCD2E8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.757 73.775L134.598 73.4682L134.547 71.7298L132.603 71.7809C132.296 71.7809 132.041 72.1388 132.041 72.4967V73.1103C132.143 73.5193 132.45 73.8261 132.757 73.775Z",
    fill: "#959AA3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.805 64.5718L143.856 65.9011C143.856 66.3102 144.316 66.617 144.726 66.4636L145.339 66.2079C145.595 66.1057 145.749 65.85 145.749 65.5944L145.697 63.7026C145.697 63.2936 145.288 62.9868 144.879 63.1402C144.163 63.3447 143.754 63.9071 143.805 64.5718Z",
    fill: "#ACB2BF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5765 23.8726C94.085 23.8726 94.4972 23.4606 94.4972 22.9523C94.4972 22.444 94.085 22.032 93.5765 22.032C93.068 22.032 92.6558 22.444 92.6558 22.9523C92.6558 23.4606 93.068 23.8726 93.5765 23.8726Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M105.239 23.8726C105.747 23.8726 106.159 23.4606 106.159 22.9523C106.159 22.444 105.747 22.032 105.239 22.032C104.73 22.032 104.318 22.444 104.318 22.9523C104.318 23.4606 104.73 23.8726 105.239 23.8726Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 23.8726C117.409 23.8726 117.821 23.4606 117.821 22.9523C117.821 22.444 117.409 22.032 116.9 22.032C116.392 22.032 115.98 22.444 115.98 22.9523C115.98 23.4606 116.392 23.8726 116.9 23.8726Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5765 34.2521C94.085 34.2521 94.4972 33.84 94.4972 33.3317C94.4972 32.8235 94.085 32.4114 93.5765 32.4114C93.068 32.4114 92.6558 32.8235 92.6558 33.3317C92.6558 33.84 93.068 34.2521 93.5765 34.2521Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M105.239 34.2521C105.747 34.2521 106.159 33.84 106.159 33.3317C106.159 32.8235 105.747 32.4114 105.239 32.4114C104.73 32.4114 104.318 32.8235 104.318 33.3317C104.318 33.84 104.73 34.2521 105.239 34.2521Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 34.2521C117.409 34.2521 117.821 33.84 117.821 33.3317C117.821 32.8235 117.409 32.4114 116.9 32.4114C116.392 32.4114 115.98 32.8235 115.98 33.3317C115.98 33.84 116.392 34.2521 116.9 34.2521Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5765 44.5802C94.085 44.5802 94.4972 44.1681 94.4972 43.6598C94.4972 43.1516 94.085 42.7395 93.5765 42.7395C93.068 42.7395 92.6558 43.1516 92.6558 43.6598C92.6558 44.1681 93.068 44.5802 93.5765 44.5802Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M105.239 44.5802C105.747 44.5802 106.159 44.1681 106.159 43.6598C106.159 43.1516 105.747 42.7395 105.239 42.7395C104.73 42.7395 104.318 43.1516 104.318 43.6598C104.318 44.1681 104.73 44.5802 105.239 44.5802Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 44.5802C117.409 44.5802 117.821 44.1681 117.821 43.6598C117.821 43.1516 117.409 42.7395 116.9 42.7395C116.392 42.7395 115.98 43.1516 115.98 43.6598C115.98 44.1681 116.392 44.5802 116.9 44.5802Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5765 54.9594C94.085 54.9594 94.4972 54.5473 94.4972 54.039C94.4972 53.5308 94.085 53.1187 93.5765 53.1187C93.068 53.1187 92.6558 53.5308 92.6558 54.039C92.6558 54.5473 93.068 54.9594 93.5765 54.9594Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M105.239 54.9594C105.747 54.9594 106.159 54.5473 106.159 54.039C106.159 53.5308 105.747 53.1187 105.239 53.1187C104.73 53.1187 104.318 53.5308 104.318 54.039C104.318 54.5473 104.73 54.9594 105.239 54.9594Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 54.9594C117.409 54.9594 117.821 54.5473 117.821 54.039C117.821 53.5308 117.409 53.1187 116.9 53.1187C116.392 53.1187 115.98 53.5308 115.98 54.039C115.98 54.5473 116.392 54.9594 116.9 54.9594Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5765 65.2875C94.085 65.2875 94.4972 64.8754 94.4972 64.3671C94.4972 63.8588 94.085 63.4468 93.5765 63.4468C93.068 63.4468 92.6558 63.8588 92.6558 64.3671C92.6558 64.8754 93.068 65.2875 93.5765 65.2875Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M105.239 65.2875C105.747 65.2875 106.159 64.8754 106.159 64.3671C106.159 63.8588 105.747 63.4468 105.239 63.4468C104.73 63.4468 104.318 63.8588 104.318 64.3671C104.318 64.8754 104.73 65.2875 105.239 65.2875Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 65.2875C117.409 65.2875 117.821 64.8754 117.821 64.3671C117.821 63.8588 117.409 63.4468 116.9 63.4468C116.392 63.4468 115.98 63.8588 115.98 64.3671C115.98 64.8754 116.392 65.2875 116.9 65.2875Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M184.979 85.6881C187.663 85.6881 189.838 83.5135 189.838 80.8308C189.838 78.1482 187.663 75.9736 184.979 75.9736C182.296 75.9736 180.12 78.1482 180.12 80.8308C180.12 83.5135 182.296 85.6881 184.979 85.6881Z",
    fill: "#646BAE"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M184.57 77.9677C185.235 77.9677 185.849 78.2234 186.309 78.6324C185.9 77.7632 185.03 77.2008 184.007 77.2008C182.575 77.2008 181.45 78.3256 181.45 79.7573C181.45 80.4731 181.757 81.1378 182.268 81.649C182.115 81.2911 182.013 80.9332 182.013 80.5242C182.013 79.0926 183.138 77.9677 184.57 77.9677Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0681 78.7856C84.7517 78.7856 86.9272 76.6109 86.9272 73.9283C86.9272 71.2457 84.7517 69.071 82.0681 69.071C79.3845 69.071 77.209 71.2457 77.209 73.9283C77.209 76.6109 79.3845 78.7856 82.0681 78.7856Z",
    fill: "#646BAE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6589 71.014C82.3238 71.014 82.9376 71.2697 83.3979 71.6787C82.9887 70.8095 82.1192 70.2471 81.0962 70.2471C79.6641 70.2471 78.5388 71.3719 78.5388 72.8036C78.5388 73.5194 78.8457 74.1841 79.3572 74.6954C79.2037 74.3374 79.1014 73.9795 79.1014 73.5705C79.1014 72.19 80.2267 71.014 81.6589 71.014Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M120.839 197.815C123.523 197.815 125.698 195.64 125.698 192.958C125.698 190.275 123.523 188.1 120.839 188.1C118.155 188.1 115.98 190.275 115.98 192.958C115.98 195.64 118.155 197.815 120.839 197.815Z",
    fill: "#646BAE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M120.43 190.095C121.095 190.095 121.708 190.35 122.169 190.759C121.76 189.89 120.89 189.328 119.867 189.328C118.435 189.328 117.31 190.453 117.31 191.884C117.31 192.6 117.617 193.265 118.128 193.776C117.975 193.418 117.872 193.06 117.872 192.651C117.872 191.219 118.998 190.095 120.43 190.095Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M266.562 98.3683C269.245 98.3683 271.421 96.1936 271.421 93.511C271.421 90.8284 269.245 88.6537 266.562 88.6537C263.878 88.6537 261.703 90.8284 261.703 93.511C261.703 96.1936 263.878 98.3683 266.562 98.3683Z",
    fill: "#FC8E05"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M266.152 90.5968C266.817 90.5968 267.431 90.8524 267.892 91.2614C267.482 90.3922 266.613 89.8298 265.59 89.8298C264.158 89.8298 263.032 90.9547 263.032 92.3863C263.032 93.1021 263.339 93.7668 263.851 94.2781C263.697 93.9202 263.595 93.5623 263.595 93.1532C263.595 91.7727 264.771 90.5968 266.152 90.5968Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M140.838 34.0984C143.522 34.0984 145.697 31.9237 145.697 29.2411C145.697 26.5585 143.522 24.3838 140.838 24.3838C138.154 24.3838 135.979 26.5585 135.979 29.2411C135.979 31.9237 138.154 34.0984 140.838 34.0984Z",
    fill: "#FC8E05"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M140.429 26.378C141.094 26.378 141.708 26.6337 142.168 27.0427C141.759 26.1735 140.889 25.6111 139.866 25.6111C138.434 25.6111 137.309 26.7359 137.309 28.1676C137.309 28.8834 137.616 29.548 138.127 30.0593C137.974 29.7014 137.871 29.3435 137.871 28.9345C137.871 27.5029 138.997 26.378 140.429 26.378Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M210.247 190.503C203.291 186.311 191.731 186.208 184.417 190.248C177.154 194.287 176.898 200.985 183.905 205.177C190.862 209.37 202.421 209.472 209.736 205.433C216.999 201.394 217.203 194.696 210.247 190.503Z",
    fill: "#236687"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M217.152 185.033C217.101 183.396 217.101 183.294 216.947 182.221C216.641 180.584 216.641 180.533 216.334 179.511C215.822 177.977 215.822 177.926 215.362 176.903C214.646 175.471 214.595 175.42 214.032 174.449C213.162 173.222 213.06 173.068 212.293 172.148C211.219 170.972 211.116 170.921 210.094 170.001C208.866 169.08 208.815 168.978 207.69 168.313C206.36 167.546 206.308 167.546 205.388 167.137C204.416 166.728 204.16 166.626 203.751 166.524V167.291C207.025 169.285 206.922 172.404 203.495 174.295C200.068 176.187 194.647 176.136 191.373 174.193C189.736 173.222 188.969 171.995 188.969 170.716V170.768C188.969 169.796 188.969 168.671 188.969 167.546C188.713 167.649 188.458 167.802 188.048 168.007C186.821 168.722 186.258 169.08 185.031 170.103C183.854 171.125 183.752 171.228 182.831 172.25C181.859 173.426 181.757 173.529 181.092 174.551C180.274 175.932 180.223 175.983 179.762 177.005C179.148 178.488 179.097 178.539 178.79 179.613C178.381 181.198 178.381 181.249 178.228 182.323C178.074 183.959 178.023 184.01 178.023 185.135C178.023 185.595 178.023 186.209 178.074 186.72C178.126 187.333 178.228 188.1 178.33 188.714L178.432 189.225C178.944 191.219 178.944 191.27 179.404 192.395C179.609 192.804 179.813 193.367 180.018 193.776C180.376 194.44 180.836 195.259 181.246 195.872C181.501 196.23 181.808 196.69 182.064 197.048C182.575 197.662 183.292 198.48 183.854 199.042C184.417 199.605 185.235 200.269 185.849 200.78C186.309 201.138 186.974 201.547 187.486 201.854C188.918 202.672 188.918 202.672 189.787 203.03C191.117 203.593 191.117 203.593 191.885 203.797C193.163 204.155 193.163 204.155 193.777 204.257C194.953 204.462 194.953 204.462 195.567 204.513C196.744 204.615 196.744 204.615 197.306 204.615C198.483 204.615 198.483 204.615 199.045 204.564C200.222 204.462 200.222 204.462 200.836 204.36C202.063 204.104 202.063 204.104 202.728 203.951C204.058 203.541 204.058 203.541 204.774 203.286C206.155 202.672 206.206 202.672 207.025 202.212C208.457 201.343 208.559 201.292 209.48 200.576C210.861 199.451 210.963 199.349 211.986 198.275C212.242 197.968 212.651 197.559 212.907 197.201C213.367 196.588 213.981 195.719 214.39 195.054C214.799 194.287 215.311 193.213 215.669 192.395C215.873 191.935 216.078 191.322 216.231 190.861C216.385 190.35 216.538 189.685 216.641 189.174C216.589 189.379 216.487 189.634 216.385 189.839C216.589 189.123 216.794 188.305 216.896 187.64C217.101 186.822 217.152 185.8 217.152 185.033Z",
    fill: "url(#paint16_linear_929_7247)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M188.151 200.985C186.872 200.167 186.054 199.553 184.928 198.531C183.957 197.661 182.934 196.383 182.576 195.821C181.45 194.133 181.143 193.571 180.376 191.628C180.172 191.066 179.762 189.839 179.455 187.947C179.814 190.248 181.45 192.548 184.468 194.338C191.424 198.531 202.984 198.633 210.298 194.594C213.623 192.702 215.515 190.299 215.873 187.845C215.771 188.509 215.618 189.43 215.413 190.094C215.209 190.861 214.799 191.884 214.492 192.651C214.39 192.906 213.725 194.44 212.395 196.23C210.707 198.531 208.252 200.576 205.593 201.854C202.728 203.235 199.813 203.797 196.641 203.644C193.726 203.439 190.555 202.468 188.151 200.985Z",
    fill: "#7D2834"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M210.758 179.613C203.802 175.42 192.243 175.318 184.928 179.357C177.665 183.396 177.409 190.094 184.417 194.287C191.373 198.48 202.933 198.582 210.247 194.543C217.51 190.503 217.766 183.805 210.758 179.613Z",
    fill: "url(#paint17_linear_929_7247)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M189.634 181.095C187.895 183.447 185.082 184.317 183.292 183.038C181.553 181.76 181.501 178.795 183.292 176.443C185.031 174.091 187.844 173.222 189.634 174.5C191.373 175.778 191.373 178.744 189.634 181.095Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M187.486 187.896C186.974 189.174 185.798 189.89 184.775 189.532C183.803 189.123 183.394 187.793 183.905 186.515C184.417 185.237 185.593 184.521 186.616 184.879C187.588 185.288 187.997 186.617 187.486 187.896Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M206.309 155.786H188.713V169.847H206.309V155.786Z",
    fill: "url(#paint18_linear_929_7247)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M188.713 170.818V161.564C188.713 162.842 189.532 164.12 191.169 165.092C194.544 167.137 200.12 167.188 203.649 165.194C205.439 164.172 206.36 162.842 206.36 161.513V170.767C206.36 172.097 205.439 173.477 203.649 174.449C200.12 176.392 194.544 176.34 191.169 174.346C189.532 173.375 188.765 172.097 188.713 170.818Z",
    fill: "url(#paint19_linear_929_7247)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M186.77 156.655V154.968C186.77 156.502 187.793 158.087 189.787 159.263C193.931 161.768 200.733 161.82 205.03 159.416C207.229 158.189 208.354 156.553 208.354 154.866V156.553C208.354 158.189 207.229 159.826 205.03 161.104C200.733 163.507 193.879 163.456 189.787 160.95C187.742 159.774 186.77 158.24 186.77 156.655Z",
    fill: "url(#paint20_linear_929_7247)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M205.337 150.622C209.48 153.128 209.326 157.065 205.03 159.468C200.733 161.871 193.879 161.82 189.787 159.314C185.644 156.809 185.798 152.872 190.094 150.469C194.34 148.066 201.194 148.117 205.337 150.622Z",
    fill: "#E3E7F2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M197.511 159.468C194.902 159.468 192.396 158.854 190.657 157.832C189.276 157.014 188.457 155.94 188.509 154.968C188.509 153.946 189.429 152.872 190.913 152.003C192.703 151.031 195.056 150.469 197.562 150.469C200.171 150.469 202.677 151.083 204.416 152.105C205.797 152.923 206.615 153.997 206.564 154.968C206.564 155.991 205.643 157.065 204.16 157.934C202.37 158.905 200.017 159.468 197.511 159.468Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M190.913 153.588C192.703 152.616 195.056 152.054 197.562 152.054C200.171 152.054 202.677 152.668 204.416 153.69C205.439 154.304 206.104 155.02 206.411 155.735C206.513 155.48 206.564 155.224 206.564 154.968C206.564 153.997 205.797 152.923 204.416 152.105C202.677 151.031 200.171 150.469 197.562 150.469C195.056 150.469 192.703 151.031 190.913 152.003C189.378 152.872 188.509 153.946 188.509 154.968C188.509 155.224 188.56 155.531 188.662 155.787C188.969 154.968 189.787 154.201 190.913 153.588Z",
    fill: "#576A7A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_929_7247",
    x1: 59.0415,
    y1: 109.381,
    x2: 293.407,
    y2: 109.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_929_7247",
    x1: 58.7801,
    y1: 109.383,
    x2: 293.146,
    y2: 109.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_929_7247",
    x1: 58.5205,
    y1: 109.385,
    x2: 292.888,
    y2: 109.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_929_7247",
    x1: 59.1439,
    y1: 109.386,
    x2: 293.509,
    y2: 109.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_929_7247",
    x1: 58.9886,
    y1: 111.252,
    x2: 292.572,
    y2: 111.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_929_7247",
    x1: 58.6016,
    y1: 111.329,
    x2: 292.462,
    y2: 111.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C14152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B43244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_929_7247",
    x1: 59.0422,
    y1: 110.529,
    x2: 292.628,
    y2: 110.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_929_7247",
    x1: 59.351,
    y1: 110.776,
    x2: 292.932,
    y2: 110.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_929_7247",
    x1: 58.6745,
    y1: 111.127,
    x2: 292.26,
    y2: 111.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_929_7247",
    x1: 58.7834,
    y1: 109.38,
    x2: 292.919,
    y2: 109.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_929_7247",
    x1: 58.7324,
    y1: 110.869,
    x2: 292.963,
    y2: 110.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_929_7247",
    x1: 58.967,
    y1: 111.273,
    x2: 293.216,
    y2: 111.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_929_7247",
    x1: 59.216,
    y1: 111.143,
    x2: 292.979,
    y2: 111.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_929_7247",
    x1: 59.379,
    y1: 110.9,
    x2: 293.169,
    y2: 110.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_929_7247",
    x1: 59.469,
    y1: 111.04,
    x2: 294.913,
    y2: 111.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_929_7247",
    x1: 59.7398,
    y1: 111.566,
    x2: 293.691,
    y2: 111.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_929_7247",
    x1: 59.178,
    y1: 110.965,
    x2: 293.039,
    y2: 110.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_929_7247",
    x1: 59.2691,
    y1: 111.235,
    x2: 293.023,
    y2: 111.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C14152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B43244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_929_7247",
    x1: 58.9864,
    y1: 111.089,
    x2: 292.943,
    y2: 111.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_929_7247",
    x1: 58.9864,
    y1: 111.563,
    x2: 293.437,
    y2: 111.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#D7DCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#DFE4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_929_7247",
    x1: 58.6817,
    y1: 111.744,
    x2: 292.768,
    y2: 111.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThu);
export default __webpack_public_path__ + "static/media/thu.2ca4d1367d9786cc6c5cc8ac42206851.svg";
export { ForwardRef as ReactComponent };